export const formatDate = (date: number) => {
  const dateObj = new Date(date);
  const datee = dateObj.toLocaleDateString('en-GB');
  const time = dateObj.toLocaleTimeString();

  return `${datee}, ${time}`;
};
